import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables'
import ArrowLeft from '@/assets/icons/ArrowLeft.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { ref, computed } from 'vue'
import { mdiCheck, mdiChevronDown, mdiChevronUp, mdiMagnify } from '@mdi/js'
import QRCodeScanner from '@/features/tickets/ui/front-desk/QRCodeScanner.vue'
import { useFrontdeskQuery } from '@/features/tickets/api/queries'
import { centsToDollars } from '@/services/currency'
import CreditCard from '@/assets/icons/CreditCard.vue'
import CurrencyDollar from '@/assets/icons/CurrencyDollar.vue'
import CreditCardFilled from '@/assets/icons/CreditCardFilled.vue'
import CashPayment from '@/assets/icons/CashPayment.vue'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { useImage } from '@/shared/composables/image'
import AdminTicketModal from '@/features/tickets/ui/AdminTicketModal.vue'
import AddAttendeeModal from '@/features/tickets/ui/AddAttendeeModal.vue'
import { IFrontdeskTicket, IFrontdeskRegistrant } from '@/features/tickets/types'
import { ModalWrapper } from '@/shared/ui/modals'
import AdminUserTicketsInterface from '@/features/tickets/ui/AdminUserTicketsInterface.vue'
import { useEventQuery } from '@/enitites/event/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'FrontdeskPage',
  setup(__props) {

const route = useRoute()
const { getImageById } = useImage()
const {
  data: frontdesk,
  isLoading: isFrontdeskLoading,
  error: frontdeskError,
} = useFrontdeskQuery(Number(route.params.eventId))
const { data: event } = useEventQuery(Number(route.params.eventId))

const searchQuery = ref('')
const showBreakdown = ref(false)

const isModalOpen = ref(false)
const selectedTicket = ref<IFrontdeskTicket | undefined>(undefined)
const selectedQRCode = ref<string | undefined>(undefined)

const isAddAttendeeModalOpen = ref(false)
const prefilledUser = ref<IFrontdeskRegistrant | undefined>(undefined)

const handleQRCodeDecode = (decodedString: string) => {
  selectedQRCode.value = decodedString
  selectedTicket.value = undefined
  isModalOpen.value = true
}

const openModalWithTicket = (ticket: IFrontdeskTicket) => {
  selectedTicket.value = ticket
  selectedQRCode.value = undefined
  isModalOpen.value = true
}

const closeModal = () => {
  isModalOpen.value = false
  selectedTicket.value = undefined
  selectedQRCode.value = undefined
}

const openAddAttendeeModal = (user?: IFrontdeskRegistrant) => {
  prefilledUser.value = user
  isAddAttendeeModalOpen.value = true
}

const closeAddAttendeeModal = () => {
  isAddAttendeeModalOpen.value = false
  prefilledUser.value = undefined
}

const handleAttendeeAdded = () => {
  closeAddAttendeeModal()
}

const handleManageTicket = (ticketId: number) => {
  const ticket = frontdesk.value?.tickets?.find((t) => t.id === ticketId)
  if (!ticket) return
  closeAddAttendeeModal()
  openModalWithTicket(ticket)
}

const filteredTickets = computed(() => {
  if (!frontdesk.value) return []
  const allRecords = [...(frontdesk.value.tickets || []), ...(frontdesk.value.battleRegistrantsNoTicket || [])]
  if (!searchQuery.value.trim()) return allRecords

  const query = searchQuery.value.toLowerCase().trim()
  return allRecords.filter((ticket) => {
    const dancerName =
      'assignedTo' in ticket
        ? ticket.assignedTo?.dancerName?.toLowerCase() || ''
        : ticket.dancerName?.toLowerCase() || ''
    const email =
      'assignedTo' in ticket ? ticket.assignedTo?.email?.toLowerCase() || '' : ticket.email?.toLowerCase() || ''
    return dancerName.includes(query) || email.includes(query)
  })
})

return { __sfc: true,route, getImageById, frontdesk, isFrontdeskLoading, frontdeskError, event, searchQuery, showBreakdown, isModalOpen, selectedTicket, selectedQRCode, isAddAttendeeModalOpen, prefilledUser, handleQRCodeDecode, openModalWithTicket, closeModal, openAddAttendeeModal, closeAddAttendeeModal, handleAttendeeAdded, handleManageTicket, filteredTickets, ArrowLeft, BKInput, BKButton, mdiCheck, mdiChevronDown, mdiChevronUp, mdiMagnify, QRCodeScanner, centsToDollars, CreditCard, CurrencyDollar, CreditCardFilled, CashPayment, AvatarPlaceholder, AdminTicketModal, AddAttendeeModal, ModalWrapper, AdminUserTicketsInterface }
}

})